var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app-user-wrapper"},[_c('Navbar'),_c('v-main',[_c('div',{staticClass:"user-content",class:{ 'user-content--mobile': _vm.$vuetify.breakpoint.smAndDown }},[_c('router-view')],1)]),_c('UserFloatingChat'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }